module.exports = __webpack_public_path__ + "static/media/identity-tbd-social.36b6ed42.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/static/identity-tbd-social.jpg
// module id = 258
// module chunks = 0